module.exports = __webpack_public_path__ + "fonts/RenaultLife-BoldItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-BoldItalic.ttf
// module id = 353
// module chunks = 0